import React, { useContext } from 'react';
import { ICommonData } from './ICommonData';

export const CommonDataContext = React.createContext<ICommonData>(
	{} as ICommonData,
);
export const CommonDataProvider = CommonDataContext.Provider;
export const useCommonData = () => useContext(CommonDataContext);
